import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import SuperAdminPortalPage from "./ui";

const SuperAdminPortal = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <SuperAdminPortalPage />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default SuperAdminPortal;
